/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-unused-vars */
import TextInput from "components/TextInput";
import React, { useRef } from "react";
// import PropTypes from "prop-types";
import FileUpload from "components/FileUpload";
import styled from "styled-components";
import Svg from "_assets/svg";

const Wrapper = styled.div`
  width: 100%;
  border: 1px solid #e4e7ed;
  box-sizing: border-box;
  border-radius: 8px;
  min-height: 50px;
  margin-block: 15px;
  padding: 20px;
`;

const Animation = styled.div`
  max-height: ${(props) => (!props.active ? "0px" : "1000px")};
  transition: all 0.5s ease-out;
  overflow: hidden;
`;

const UploadContainer = styled.div``;

const ButtonUpload = styled.button`
  padding: 10px 15px;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  color: #26292d;
  border: 1px solid #bbc1c8;
  background: #f5f6f8;
  box-sizing: border-box;
  border-radius: 8px;
`;

const Img = styled.img`
  width: 18.33px;
  height: 18.33px;
  margin-right: 10.42px;
  top: -1px;
  position: relative;
`;

const UploadImage = ({ handleUpload }) => {
  const uploadRef = useRef();
  return (
    <div className="margin-top-20 margin-bottom-20">
      <label className="margin-bottom-5">Logo / Image Profile Sender</label>
      <UploadContainer>
        <input
          ref={uploadRef}
          type="file"
          id="upload-button"
          style={{ display: "none" }}
          onChange={handleUpload}
        />
        <ButtonUpload onClick={() => uploadRef.current?.click()}>
          <Img src={Svg.attachment.default} />
          Upload photos
        </ButtonUpload>
      </UploadContainer>
    </div>
  );
};

const WhatsappChannel = (props) => {
  const { form, onChange, active, validation } = props;

  return (
    <Animation active={active}>
      <Wrapper>
        <TextInput
          title="Application name"
          value={form.senderName}
          placeholder="E.g. PT Omni Communication Assistant"
          className="margin-bottom-15 input-auth"
          onChange={(event) => onChange({ ...form, senderName: event.target.value })}
          invalidFeedback={validation.senderName}
        />
        <UploadImage
          handleUpload={(e) =>
            onChange({
              ...form,
              image: {
                view: URL.createObjectURL(e.target.files[0]),
                raw: e.target.files[0],
              },
            })
          }
        />
      </Wrapper>
    </Animation>
  );
};

WhatsappChannel.propTypes = {};

export default WhatsappChannel;
